
<div class="h-100">
  <div class="d-flex p-1 pb-2 header align-items-center">
    <div class="flex-grow-1 my-auto text-right">
      <span v-text="records"></span>
    </div>
    <div v-if="ready" class="ml-2 dropdown">
      <button class="btn btn-link text-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fas fa-ellipsis-v"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" href="#" @click.prevent="downloadCSV">
          <i class="fas fa-download mr-2"></i>
          Download CSV
        </a>
      </div>
    </div>
  </div>
  <template v-if="ready">
    <scroll-area class="pr-3">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>
              <span>Contract Id</span>
            </th>
            <th>
              <span>Date</span>
            </th>
            <th>
              <span>Item</span>
            </th>
            <th>
              <span>Modified by</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(audit, i) in allAudits" :key="audit._id">
            <td>
              <a v-if="audit.ref"
                class="badge badge-custom"
                title="View contract"
                v-text="audit.id"
              ></a>
              <span v-else></span>
            </td>
            <td>
              <span v-text="audit.date"></span>
            </td>
            <td>
              <span v-text="audit.item"></span>
            </td>
            <td>
              <span v-text="audit.user ? `${audit.user.name} - ${audit.user.email}` : ``"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </scroll-area>
  </template>
  <template v-else>
    <loading></loading>
  </template>
</div>
